import { DateFormatPipe } from '@ui-components';
import { gameLevelMapper } from '@core';
import { CreateHostedGameResponse, UpdateHostedGameResponse } from '@core-http';
import { CreateGameCommandResult } from '../command/create-game/create-game.command-result';

export const mapToCreateGameResultUtil = (
  game: CreateHostedGameResponse | UpdateHostedGameResponse,
  dateFormatPipe: DateFormatPipe
): CreateGameCommandResult => {
  return {
    gameName: game.name,
    gameId: game.gameId,
    formattedDate: dateFormatPipe.transform(game.gameDateStart, game.gameDateEnd),
    location: game.location,
    level: gameLevelMapper[game.level],
    priceAmount: +game.priceAmount
  };
};
